import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { HeroPage } from '../../components/HeroPage/HeroPage';
import { TeamPage } from '../../components/TeamPage/TeamPage';
import { OffersPage } from '../../components/OffersPage/OffersPage';
import { HowItWorks } from '../../components/HowItWorks/HowItWorks';
import { WhyRenuit } from '../../components/WhyRenuit/WhyRenuit';
import { FAQPage } from '../../components/FAQPage/FAQPage';
import { ContactPage } from '../../components/ContactPage/ContactPage';

export const HomePage = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Handle hash-based deep linking from other pages (e.g. /#contact)
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      const el = document.getElementById(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 120);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Renuit Logistics — SE US Freight &amp; 3PL</title>
        <meta name="description" content="FTL &amp; LTL freight brokerage, warehousing, and last-mile delivery across FL, GA, AL, TN and the Gulf Coast. Licensed 3PL based in St. Petersburg, FL." />
        <link rel="canonical" href="https://www.renuit.pro/" />
        <meta property="og:title" content="Renuit Logistics — SE US Freight &amp; 3PL" />
        <meta property="og:description" content="FTL, LTL, warehousing, and last-mile delivery across the Southeast US and Gulf Coast. Licensed, bonded, insured." />
        <meta property="og:url" content="https://www.renuit.pro/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.renuit.pro/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@RenuitLogistics" />
        <meta name="twitter:title" content="Renuit Logistics — SE US Freight &amp; 3PL" />
        <meta name="twitter:description" content="FTL, LTL, warehousing, and last-mile delivery across the Southeast US and Gulf Coast. Licensed, bonded, insured." />
        <meta name="twitter:image" content="https://www.renuit.pro/og-image.jpg" />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FreightForwarder',
          name: 'Renuit Logistics',
          url: 'https://www.renuit.pro/',
          logo: 'https://www.renuit.pro/renuit_logo.png',
          image: 'https://www.renuit.pro/og-image.jpg',
          description: 'Licensed freight broker and 3PL providing FTL, LTL, warehousing, and last-mile delivery across the Southeast US and Gulf Coast.',
          telephone: '+17866283731',
          email: 'support@renuit.pro',
          priceRange: '$$',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '360 Central Avenue, Office #310',
            addressLocality: 'St. Petersburg',
            addressRegion: 'FL',
            postalCode: '33701',
            addressCountry: 'US',
          },
          areaServed: [
            { '@type': 'State', name: 'Florida' },
            { '@type': 'State', name: 'Georgia' },
            { '@type': 'State', name: 'Alabama' },
            { '@type': 'State', name: 'Mississippi' },
            { '@type': 'State', name: 'Louisiana' },
            { '@type': 'State', name: 'South Carolina' },
            { '@type': 'State', name: 'North Carolina' },
            { '@type': 'State', name: 'Tennessee' },
          ],
          sameAs: [
            'https://www.linkedin.com/company/renuit-logistics',
            'https://twitter.com/RenuitLogistics',
          ],
          openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '08:00',
            closes: '18:00',
          },
        })}</script>
      </Helmet>
      <HeroPage />
      <TeamPage />
      <OffersPage />
      <HowItWorks />
      <WhyRenuit />
      <FAQPage />
      <ContactPage isSubmitted={isSubmitted} setIsSubmitted={setIsSubmitted} />
    </>
  );
};
